<template>
    <div class="business">
      <mHead ></mHead>
      <div class="main">
            <div class="titleDiv">
                资讯
            </div>
            <div class="list" v-if="list.length > 0">
                <div class="item" v-for="item in list" :key="item.id" @click="toDetail(item)">
                    <img :src="item.imageUrl" alt="">
                    <p class="name">
                        {{item.name}}
                    </p>
                    <p class="content" v-html="item.remarks"></p>
                    <p class="time">
                        {{item.createTime | formatDate('MM/dd/yyyy')}}
                    </p>
                </div>
            </div>
            <div class="nodata" v-else>
                <p>暂无数据...</p>
            </div>
            <div class="pagination" v-if="pageNum > 1">
                <span v-for="item in pageNum" :key="item" :class="selectNum == (item - 1)?'on':''" @click="changePage(item)">
                    {{item}}
                </span>
                <span class="last" v-if="pageNum > 2" @click="changePage(pageNum)"></span>
            </div>
      </div>
      <mBottom></mBottom>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import mHead from '@/components/base/pc/mHead.vue'
import mBottom from '@/components/base/pc/mBottom.vue'
export default {
    components:{ mHead, mBottom },
    data() {
        return {
            imgList: [],
            pageNum: 0,
            selectNum: 0,
            allList: [], 
            list: [
            
            ]
        }
    },
    computed: mapState({
    // 映射 this.count 为 store.state.count
       
        // swiper() {
        //     return this.$refs.mySwiper.swiper
        // },
    }),
    mounted(){
        // this.getList();
        this.statistics();
        this.getInfoList();
    },
    beforeDestroy(){
        
    },
    methods: {
        getList(){
            this.$http.get(this.service.dev.api.recommendList+'?pageId=2' ).then(response =>{
              if(response.status == 200){
                  let list = response.body || []
                  if(list.length > 0){
                    let heightList = list[0].keyDesc.split(',');
                    let urlList = list[0].content.split(',');
                    urlList.map((em,ind) => {
                        this.imgList.push({ height: heightList[ind], url: em})
                    })
                }
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
        getInfoList(){
            this.$http.get(this.service.dev.api.infoList ).then(response =>{
              if(response.status == 200){
                  let list = (response.body || []).filter(item => {
                      return item.status == 1;
                  })

                  this.allList = list;
                  this.pageNum = Math.ceil(list.length/4);
                  this.list = list.slice(this.selectNum, 4);
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
        changePage(num) {
            this.selectNum = num - 1;
            
            this.list = this.allList.slice(this.selectNum*4,this.selectNum*4+4)
            
            // window.scrollTo({
            //     top: this.$refs.caseNav.offsetTop - 100,
            //     behavior: 'smooth'
            // })
        },
        toDetail(item) {
            this.$router.push('/businessDetail/'+ item.id)
        },
        statistics(){
            this.$http.post(this.service.dev.api.statistics, {pageName: '资讯列表'} ).then(response =>{
              
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .business {
        background: #FAFAFA;
        .main {
            text-align: left;
            width: 75%;
            margin: 130px auto 0;
            min-width: 1200px;
            .nodata {
                margin-top: 120px;
                text-align: center;
            }
            .list {
                margin-top: 40px;
                width: 100%;
                .item {
                    width: calc((100% - 80px)/2);
                    display: inline-block;
                    margin-bottom: 80px;
                    cursor: pointer;
                    &:nth-child(odd) {
                        margin-right: 80px;
                    }
                    img{
                        width: 100%;
                    }
                    .name {
                        font-size: 16px;
                        margin-top: 14px;
                    }
                    .content {
                        width: 100%;
                        font-size: 14px;
                        color: rgba(0,0,0,0.4);
                        height: 20px;
                        line-height: 20px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        margin-top: 6px;
                    }
                    .time {
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.2);
                        margin-top: 24px;
                    }
                }
            }
            .pagination {
                padding-bottom: 80px;
                text-align: center;
                span {
                    display: inline-block;
                    width: 36px;
                    height: 36px;
                    color: rgba(0, 0, 0, 0.2);
                    background: rgba(0, 0, 0, 0.02);
                    line-height: 36px;
                    margin-right: 1px;
                    font-size: 16px;
                    cursor: pointer;
                    text-align: center;
                    &.on {
                        color: rgba(0, 0, 0, 0.8);
                    }
                    &:hover {
                        color: rgba(0, 0, 0, 0.8);
                    }
                    &.last {
                        margin-left: -4px;
                        &:after {
                            content: '';
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            border: 1px solid rgba(0, 0, 0, 0.2);
                            border-bottom: none;
                            border-left: none;
                            transform: rotate(45deg) translateY(-2px);
                            margin-right: 5px;
                        }
                        &:hover {
                            &:after { 
                                border-color: rgba(0, 0, 0, 0.8);
                            }
                        }
                    }
                }
            }
        }
    }


</style>
<style lang="scss">
    .business {
        .main {
            .list {
                .item {
                    .content {
                        >div {
                            display: inline!important;
                        }
                    }
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/modules/view/business/index.vue